import { render, staticRenderFns } from "./ConfirmEmail.vue?vue&type=template&id=ff003c1c&scoped=true&"
import script from "./ConfirmEmail.js?vue&type=script&lang=js&"
export * from "./ConfirmEmail.js?vue&type=script&lang=js&"
import style0 from "./ConfirmEmail.vue?vue&type=style&index=0&id=ff003c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff003c1c",
  null
  
)

export default component.exports